import { notifications } from '@mantine/notifications';
import { toggleUserProperty } from '../../apiClient';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useToggleUserProperty = ({ property }) => {
    const mutation = useMutation({
        mutationKey: `toggle_user_${property}`,
        mutationFn: (model) =>
            toggleUserProperty({
                ...model,
                property,
            }),
        onSuccess: (data) => {
            notifications.show({
                title: 'Success',
                message: `Successfully updated user`,
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useToggleUserProperty;
